import { CarMakeCard } from '@/components/CarMakeCard'
import { Hero } from '@/components/Hero'
import { laravelGraphqlEndpoint } from '@/globals/globals'
import { parseJSONinObject } from '@/lib/parseJSONinObject'
import { CarMake, CarModel } from '@/types/car'
import { Container, SimpleGrid } from '@chakra-ui/react'
import request, { gql } from 'graphql-request'
import { GetStaticProps } from 'next'

export const getStaticProps: GetStaticProps = async () => {
  const query = await request(
    laravelGraphqlEndpoint,
    gql`
      {
        carMakes {
          name
          id_car_make
          memberProjects {
            title
            images
            published
          }
        }
        carModels {
          name
          id_car_model
          memberProjects {
            title
            images
            published
          }
        }
      }
    `
  )

  const makesWithProjects: CarMake[] = query.carMakes.filter(
    (make: CarMake) =>
      make.memberProjects.filter(project => project.published).length > 9
  )

  const makes = makesWithProjects.map(make => {
    return {
      ...make,
      memberProjects: [
        make.memberProjects[0]
          ? parseJSONinObject(make.memberProjects[0])
          : undefined,
      ],
    }
  })

  const modelsWithProjects = query.carModels.filter(
    (model: CarModel) =>
      model.memberProjects.filter(project => project.published).length > 9
  )

  const models = modelsWithProjects.map((model: CarModel) => {
    return {
      ...model,
      memberProjects: [
        model.memberProjects[0]
          ? parseJSONinObject(model.memberProjects[0])
          : undefined,
      ],
    }
  })

  return {
    props: {
      makes,
      models,
    },
  }
}

export default function Page(props: {
  makes: CarMake[]
  models: CarModel[]
}): JSX.Element {
  return (
    <>
      <Hero heading='Nation Categories' />
      <Container py={12} maxWidth='8xl'>
        <SimpleGrid columns={[1, 2, 3]} spacing={8}>
          {props.makes.map(
            entry =>
              entry && <CarMakeCard entry={entry} key={entry.id_car_make} />
          )}
          {props.models.map(
            entry =>
              entry && <CarMakeCard entry={entry} key={entry.id_car_model} />
          )}
        </SimpleGrid>
      </Container>
    </>
  )
}
